import { createStore } from "solid-js/store";
import type { Alert } from "@houston/shared";

type AlertState = { active: Alert[]; history: Alert[] };

const [alerts, setAlerts] = createStore<AlertState>({ active: [], history: [] });

export function fireAlert(a: Alert) {
  setAlerts("active", (prev) => [a, ...prev.filter((x) => x.id !== a.id)]);
}

export function resolveAlert(id: string, resolvedAt: number) {
  setAlerts("active", (prev) =>
    prev.map((a) => (a.id === id ? { ...a, resolvedAt } : a)),
  );
  setAlerts("history", (prev) => {
    const found = alerts.active.find((a) => a.id === id);
    return found ? [{ ...found, resolvedAt }, ...prev] : prev;
  });
}

export { alerts };
